import {fetchProfileAPI} from "../api";

export const apiConfig = Object.freeze({
  profile: fetchProfileAPI
});
